<template>
    <nav
        class="router-menu"
        aria-label="Module List"
    >
        <router-link
            v-for="route in routes"
            :key="route.link"
            :to="route.link"
            tag="div"
            class="route"
        >
            <component
                :is="route.icon"
                class="module-icon"
            />
            <div
                class="route-description"
            >
                <h3
                    class="route-title"
                >
                    {{ route.title }}
                </h3>
                <p>
                    {{ route.description }}
                </p>
            </div>
        </router-link>
    </nav>
</template>

<script>
export default {
    props: {
        routes: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss">
    $color-icon-fill: #4770aa !default;

    div.route {
        cursor: pointer;
        display: grid;
        grid-template-columns: 4rem auto;
        margin-bottom: 0.8rem;

        svg.module-icon {
            fill: $color-icon-fill;
            width: 4rem;
            height: 4rem;
            grid-column: 1 / span 1;
            grid-row: 1 / span 2;
        }

        .route-description {
            grid-column: 2 / span 1;
            grid-row: 1 / span 1;

            .route-title {
                font-weight: 900;
                font-size: 1rem;
            }
        }
    }
</style>
